export const replaceUrlPersona = (url: string, persona?: string): string | undefined => {
  const urlObj = new URL(url);
  const pathParts = urlObj.pathname.split('/').filter(part => part !== '');

  if (pathParts.length === 0) {
    return url;
  }

  pathParts[0] = persona || pathParts[0];
  urlObj.pathname = '/' + pathParts.join('/');

  return urlObj.toString();
};
